var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4895 6.12598H7.51055C7.02638 6.12598 6.62634 6.52601 6.62634 7.01019V12.9891C6.62634 13.4733 7.02638 13.8733 7.51055 13.8733H13.4895C13.9737 13.8733 14.3737 13.4733 14.3737 12.9891V7.01019C14.3737 6.52601 13.9737 6.12598 13.4895 6.12598Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.98421 0 0.5 4.48421 0.5 10C0.5 15.5158 4.98421 20 10.5 20C16.0158 20 20.5 15.5158 20.5 10C20.5 4.48421 16.0158 0 10.5 0ZM10.5 18.4421C5.84737 18.4421 2.05789 14.6526 2.05789 10C2.05789 5.34737 5.84737 1.55789 10.5 1.55789C15.1526 1.55789 18.9421 5.34737 18.9421 10C18.9421 14.6526 15.1526 18.4421 10.5 18.4421Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.2123cc3324302037e27e0d5f616186de.svg";
export { ForwardRef as ReactComponent };